/* Home Care Guide — scroll reveal + care-level jump links */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // reveal on scroll
  var targets = document.querySelectorAll('.hcg-rv');
  if (!('IntersectionObserver' in window) || reduce) {
    targets.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    targets.forEach(function (el) { io.observe(el); });
  }

  // care-level links/buttons scroll to their section
  document.querySelectorAll('[data-hcg-target]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var el = document.getElementById(btn.getAttribute('data-hcg-target'));
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      el.classList.remove('is-flagged');
      void el.offsetWidth;
      el.classList.add('is-flagged');
      if (history.replaceState) {
        history.replaceState(null, '', '#' + btn.getAttribute('data-hcg-target'));
      }
    });
  });

  // pad the body when the sticky bar is present
  if (document.querySelector('.hcg-sticky')) {
    document.body.classList.add('hcg-has-sticky');
  }
  if (document.querySelector('.hcg-pp-sbar')) {
    document.body.classList.add('hcg-pp-has-sticky');
  }

  // package product page — gallery thumbnail swap
  var mainImg = document.getElementById('hcg-pp-gal-main-img');
  if (mainImg) {
    document.querySelectorAll('[data-hcg-pp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.getAttribute('data-full');
        document.querySelectorAll('[data-hcg-pp-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  }

  // package product page — sticky bar's "Add to cart" scrolls to the real form
  var ppSbarLink = document.querySelector('.hcg-pp-sbar a[href="#hcg-pp-form"]');
  if (ppSbarLink) {
    ppSbarLink.addEventListener('click', function (e) {
      var form = document.getElementById('hcg-pp-form');
      if (!form) return;
      e.preventDefault();
      form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
  }
})();
